import { createRoot } from 'react-dom/client';
import { Provider } from "react-redux";
import React from "react";
import {
    AsidePanelCardPreviewSettingsHOC
} from "../react_components/aside_panel/asidePanel/hocs/AsidePanelCardPreviewSettingsHOC/AsidePanelCardPreviewSettingsHOC";

App.Views.CardPreviewSettings = App.Views.BaseView.extend({
    asideClassName: 'aside-panel__card-preview',

    initialize: function (options) {
        this.root = createRoot(this.el);
        this.store = options.store;
        this.boardId = options.boardId;
        this.parent = options.parent;
    },

    render: function () {
        this.parent.$el.find('.aside-panel__hide').hide();
        this.root.render(
            <Provider store={this.store}>
                <AsidePanelCardPreviewSettingsHOC
                    boardId={this.boardId}
                    closedRef={document.activeElement}
                />
            </Provider>
        );
        return this;
    },

    remove: function () {
        this.parent.$el.find('.aside-panel__hide').show();
        setTimeout(() => {
            setTimeout(() => {
                this.root.unmount(); // надо дождаться пока сработает react onblur, только потом отцеплять конпонент
            });
        });
        Backbone.View.prototype.remove.call(this);
    }
});

export default App.Views.CardPreviewSettings;
